module.exports = __webpack_public_path__ + "@/assets/img/black.fbcf9409.jpeg";